import React, { useEffect, useState, useRef } from 'react';
import { Breadcrumb, Button, Col, Form, Row, Select, Table, Tabs } from 'antd';
import { AppState } from 'src/store';
import { connect } from 'react-redux';
import { getCategoriesByOrganizationIdAndYear,  getGeiYearsByOrganizationId } from 'src/store/Results/thunks';
import { getAllOrganization } from 'src/store/organization/thunks';
import { getUserByToken } from 'src/store/user/thunks';
import { Organization } from '../../../store/organization/types';
import { Category } from 'src/store/category/type';
import { CategoryResponse, CategoryResults, ResultsResponse } from 'src/store/Results/types';
import style from './Results.module.scss'
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import { useHistory, useParams } from 'react-router-dom';
import styles from 'src/globals/Layout/Admin/AdminHeader.module.scss';

interface ResultsHeaderProps{
    annual?:String,
    mensual?:String,
    history?:String
    unified?:String
    unifiedMensual?:String
    getUserByToken?:any;
}

const ResultsHeader = (props:ResultsHeaderProps) => {
    const history = useHistory();  
    const [annual, setAnnual] = useState('Resultados anuales');
    const [mensual, setMensual] = useState('Resultados mensuales');
    const [isRol, setIsRol] = useState('');
    const init = async () => {
        const rol = await props.getUserByToken();
        setIsRol(rol);
        if (rol == "administrator" || rol == "super_admin") {
            setMensual('Resultados mensuales unificados');
            setAnnual('Resultados anuales unificados');
        } else if (rol == "client") {
            setMensual('Resultados mensuales');
            setAnnual('Resultados anuales');
        }
    }
    useEffect(() => {
        init();
    }, []);


    return (
        <div>            
            <br/>           
            <div  className={style["admin-header"]}>
                <div >
                    {isRol == "super_admin" || isRol=="administrator"  && <> <span className={style["header"+props.annual]} onClick={() => history.push("/results/annual")}> Resultado anual</span><span> / </span>
                <span className={style["header"+props.mensual]} onClick={() => history.push("/results/mensual")}>Resultados mensuales</span><span> / </span></>}
                <span className={style["header"+props.unified]}  onClick={() => history.push("/results/unified/annual")}>{annual}</span><span> / </span>
                {/* <span className={style["header"+props.unifiedMensual]}  onClick={() => history.push("/results/unified/mensual")}>{mensual}</span> */}
                
                </div>
            </div>
            <br/>

        </div>

    );
};


const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
   getUserByToken
})(ResultsHeader);